import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from 'src/app/@core/services/data.service';
import { FontsService } from 'src/app/@core/services/fonts.service';
import { FeatureModel } from '../../../@core/models/feature.model';
import { FeaturesColInterface } from '../../../@core/models/site-material-data.model';

@Component({
  selector: 'app-features-col',
  templateUrl: './features-col.component.html',
  styleUrls: ['./features-col.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialFeaturesColComponent implements OnInit {

  title: string;
  titleColor: string;
  titleSize: string;
  backgroundColor: string;
  activatePadding: boolean = false;
  features: FeatureModel[];
  data: FeaturesColInterface;
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  classFeature: string = 'box';
  classFeatures: string = 'features';
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  fontWeight: string;
  titleFontFamily: string;
  titleFontFamilyName: string;
  shape: string;

  constructor(private dataService: DataService,private fontsService:FontsService) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.shape = this.data.shape ? this.data.shape : '';
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : '400';
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    this.features = this.data.features;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
}
